import { render, staticRenderFns } from "./ClaimInfoModal.vue?vue&type=template&id=73ae45f4&scoped=true&"
import script from "./ClaimInfoModal.vue?vue&type=script&lang=ts&"
export * from "./ClaimInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimInfoModal.vue?vue&type=style&index=0&id=73ae45f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae45f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VCard,VCarousel,VCarouselItem,VCol,VContainer,VDialog,VImg,VRow,VSheet})
